import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const DiversionCostaPri = ({ hasBg = true }) => {
  return (
    <>
      <section
        id="diversion"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Playa, Fiesta y mas
                  </span>
                ) : (
                  ""
                )}
                <h2>Lo mejor de la Costa Atlántica</h2>
                <p className="lead">
                  ¡Haz único tu viaje de egresados y vive una experiencia
                  inolvidable! Miles de estudiantes ya han vivido su viaje con
                  nosotros. ¡Únete y vive una experiencia inolvidable!
                </p>
              </div>
            </div>
          </div>
          <Swiper
            // install Swiper modules
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
            centeredSlides={true}
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            // autoplay= {{delay: 2000}}
            loop={true}
            // navigation
            pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            // onSlideChange={() => console.log('slide change')}
          >
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri2.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri3.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri4.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri5.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri6.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/costaAtlantica/diversion/imagenescostapri7.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default DiversionCostaPri;
